<template>
  <div class="row search">
    <InstantSearch
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import InstantSearch from './InstantSearch';

export default {
  props: ['root'],

  components: {
    InstantSearch,
  },
};
</script>

<style lang="scss">
  .search {
    margin-right: 1px;
    display: inline-flex;
  }
</style>
